/**
 * Bir ekin TAM onizleme turu - sunucudaki `services/previews.py::preview_kind`
 * ile AYNI kural.
 *
 *   pdf     -> tarayicinin PDF goruntuleyicisi
 *   office  -> .docx/.doc/.xlsx/.xls, sunucuda LibreOffice ile PDF'e cevrilmis
 *   html    -> sayfanin kendisi, sandbox'ta
 *
 * Sunucu yetkili: kural ayrisirsa uc 415 donuyor ve arayuz hatayi gosteriyor.
 */
export type FullPreviewKind = 'pdf' | 'office' | 'html'

const OFFICE_EXTENSIONS = ['.docx', '.doc', '.xlsx', '.xls']
const HTML_EXTENSIONS = ['.html', '.htm']

export function fullPreviewKindOf(filename: string, mime: string): FullPreviewKind | null {
  const lower = filename.toLowerCase()
  const dot = lower.lastIndexOf('.')
  const suffix = dot >= 0 ? lower.slice(dot) : ''
  if (mime === 'application/pdf' || suffix === '.pdf') return 'pdf'
  if (OFFICE_EXTENSIONS.includes(suffix)) return 'office'
  if (HTML_EXTENSIONS.includes(suffix) || mime === 'text/html') return 'html'
  return null
}
